import React from 'react';
import { Dropdown } from '@lwt-helix/dropdown';
import { periodDropdownItems, terms } from '../constants';

const PeriodDropdown = () => {
    return (
            <Dropdown
                dataLwtId="dashboard-period-dropdown"
                items={periodDropdownItems}
                className="mb-1 mr-2 d-inline-block align-top"
                menuProps={{
                    dataLwtId: 'share-menu',
                    right: true
                }}
                toggleProps={{
                    dataLwtId: 'no-split-toggle',
                    id: 'caret',
                    color: 'secondary',
                    caret: true,
                    children: terms.last12Months,
                    className: 'btn btn-sm btn-secondary',
                    disabled: true,
                }}
            />
    );
};

export default PeriodDropdown;
